// 环境变量配置
export const ENV = {
  // API 基础 URL
  API_BASE_URL:
    process.env.NODE_ENV === 'production'
      ? window.location.origin
      : 'http://localhost:8080',

  // 是否为开发环境
  isDev: process.env.NODE_ENV === 'development',

  // 是否为生产环境
  isProd: process.env.NODE_ENV === 'production',
} as const;
